import React from 'react';
import { Box, Typography } from '@material-ui/core';

import useCar from '../../../../../../context/useCar';
import { useTranslations } from 'components/utilities';

const Price = () => {
	const { t } = useTranslations();

	const {
		carDetails: { gross_amount, number_of_days }
	} = useCar();

	return (
		<Box textAlign="center" py={2}>
			<Typography gutterBottom>
				{ t('car.totalPriceHeader', {days: number_of_days}) }
			</Typography>
			<Typography variant="h2" color="secondary" gutterBottom>
				{gross_amount}{' '}
				<Typography variant="h5" component="span">
					{ t('common.sar') }
				</Typography>
			</Typography>
			<Typography variant="h6" color="textSecondary">
				{ t('car.includeVAT') }
			</Typography>
		</Box>
	);
};

export default Price;
